import iziToast from 'izitoast';

import React, {useEffect, useRef} from 'react';

import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import {LinearProgress, withStyles} from "@material-ui/core";
import {navigate} from "@reach/router";
import Logo from "../../../assets/Fidelius_Finalized_Logo_Parts-02.svg";
import routes from "../../../utils/api-client";

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#f5f5fa',
  },
  barColorPrimary: {
    backgroundColor: '#02B085',
  },
  animationDuration: '2550ms',

})(LinearProgress);

function VaultCreateModal(props){

  let vaultId = useRef();

  useEffect(() => {
    if (props.open) {
      routes.createVault(props.vault).subscribe((response) => {
        if (response.status === 200) {
          vaultId.current = response.data.id;
          setTimeout(() => {
            props.close();
            navigate(`/vaults/${vaultId.current}`);
            iziToast.success({
              position: "topCenter",
              'title': 'Success',
              'message': 'Successfully created your vault.'
            });
          }, 3500)
        }
      });
    }
  }, [props.open]);

  return (
    <Dialog open={props.open}>
      <div className="flex items-center mb-2">
        <img className={"logo-container right-spacer"} src={Logo}/>
        <p className="text-lg sm:text-3xl font-bold">Securing Your Vault</p>
      </div>
      <Divider/>
      <p className="text-center md:text-lg mt-6">We're configuring your Vault and securing your documents.</p>
      <div className="create-vault-progress m-auto mt-8 mb-3">
        <ColorLinearProgress/>
      </div>
      <p className="text-grey text-sm sm:text-base text-center">This should only take a moment...</p>

    </Dialog>
  );
}

export default VaultCreateModal;
